import styled from 'styled-components'

/* Groups the "Filter by" row with the active filters row so the parent
   layout gap doesn't stack on top of the 16px spec'd spacing between them. */
export const FiltersSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`
export const Wrapper = styled.div`
  display: flex;
  flex-flow: nowrap;
  justify-content: space-between;
`
export const FilterWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-left: ${({ $isDesktop }) => ($isDesktop ? '32px' : '0')};
`
export const FilterRowTitle = styled.div`
  font-size: 12px;
  font-weight: 400;
  padding: 4px 16px 4px 0;
  color: ${({ theme }) => theme.colors.neutralW90};
`
export const SortWrapper = styled.div`
  display: flex;
  align-items: center;
`
export const Sort = styled.span`
  font-size: 12px;
  font-weight: 400;
  padding: 4px 16px 4px 4px;
  color: ${({ theme }) => theme.colors.neutralW90};
`
export const ViewWrapper = styled.div`
  display: flex;
  padding-left: 16px;
`
export const ViewOptionsWrapper = styled.div`
  display: flex;
  border-radius: 5px;
  align-self: center;
  background-color: ${({ theme }) => theme.colors.neutralW20};
`
export const GridOption = styled.span`
  cursor: pointer;
  border-radius: 5px;
  padding: 4px;
  background-color: ${({ theme, $isGridActive }) =>
    $isGridActive ? theme.colors.neutralW20 : theme.colors.neutralW30};

  &:hover {
    svg {
      fill: ${({ theme }) => theme.colors.neutralW100};
    }
  }
`

export const ListOption = styled.span`
  cursor: pointer;
  border-radius: 5px;
  padding: 4px;
  background-color: ${({ theme, $isListActive }) =>
    $isListActive ? theme.colors.neutralW20 : theme.colors.neutralW30};
  &:hover {
    svg {
      fill: ${({ theme }) => theme.colors.neutralW100};
    }
  }
`
